import { Loader2 } from "lucide-react";

type LoadingProps = {
  label?: string;
  className?: string;
};

export function Loading({ label = "Loading…", className }: LoadingProps) {
  return (
    <div className={`flex items-center gap-2 text-sm text-muted-foreground ${className ?? ""}`}>
      <Loader2 className="h-4 w-4 animate-spin text-amber-300" />
      <span>{label}</span>
    </div>
  );
}

export default Loading;
